import React, { useEffect } from "react";
import useState from "react-usestateref";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Typography,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import * as Icons from "@material-ui/icons";
import { CKEditor } from "ckeditor4-react";
import apiService from "../core/service/detail";
import { getMethod } from "../core/service/common.api";
import { postMethod } from "../core/service/common.api";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import { useUserDispatch, insertBlog } from "../context/BlogContext";
import { toast } from "react-toastify";
import CKeditor from "../components/CKeditor";
import useStyles from "../components/Header/styles";
// import Pagination from "react-js-pagination";
import Pagination from "@material-ui/lab/Pagination";
import SearchBar from "./searchbar";
import Skeleton from "react-skeleton-loader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "none",
  outline: "none",
  boxShadow: 24,
  borderRadius: "10px",
  p: 4,
};

const datatableData = [
  [
    "Joe James",
    "Example Inc.",
    <img src={require("../images/logo.png")} className="image-width" />,
    <Icons.Edit className="cursor-pointer" />,
    <Icons.Delete className="cursor-pointer" />,
  ],
];

export default function Tables(props) {
  var [categoryNameList, setcategoryNameList] = useState([]);
  var [categoryNameValue, setcatagoryNameValue] = useState("");
  // var [isLoading, setIsLoading] = useState(false);
  // var [error, setError] = useState(null);
  var [blogList, setblogList, blogListref] = useState([]);
  var [
    BlocksentinalblogList,
    setBlocksentinalblogList,
    BlocksentinalblogListref,
  ] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalpages] = useState(0);
  const [BlocksentinalcurrentPage, setBlocksentinalcurrentPage] = useState(1);
  const [BlocksentinaltotalPage, setBlocksentinaltotalPages] = useState(0);
  const [pageactive, setActivePage] = useState(false);
  var [blogTitle, setblogTitle] = useState("");
  // var [catagaryurl, setcatagaryUrl] = useState("");
  var [blogSlug, setblogSlug] = useState("");
  var [blogMetatitle, setblogMetatitle] = useState("");
  var [blogMetadesc, setblogMetadesc] = useState("");
  var [blogImage, setblogImage] = useState("");
  var [blogContent, setblogContent] = useState("");
  var [blogLabel, setblogLabel] = useState("Choose file");
  var [blogStatus, setblogStausValue] = useState("Active");
  var [blogSite, setblogSite] = useState("BLF");
  var classes = useStyles();
  const [editorLoaded, setEditorLoaded] = useState(false);
  const [blogdata, setBlog, blogdataref] = useState("");
  const [pageblockloader, setpageblockloader] = useState(true);
  const [pageloader, setpageloader] = useState(true);
  const [formStatus, setformStatus] = useState(false);
  const recordPerPage = 5;
  // total number of the records
  const totalRecords = 15;
  // range of pages in paginator
  const pageRange = 5;

  const BlocksentinalrecordPerPage = 5;
  // total number of the records
  const BlocksentinaltotalRecords = 15;
  // range of pages in paginator
  const BlocksentinalpageRange = 5;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handlePageBlocksentinalChange = (pageNumber) => {
    getBlocksentinalblogList(pageNumber);
    setBlocksentinalcurrentPage(pageNumber);
    // setchoosepage()
  };
  const handlePageChange = (pageNumber) => {
    getblogList(pageNumber);
    setCurrentPage(pageNumber);
    // setchoosepage()
  };

  useEffect(() => {
    let isMounted = true;
    async function fetchData() {
      await Promise.all([
        getcategoryNameList(),
        getblogList(),
        getBlocksentinalblogList(),
      ]);

      if (isMounted) {
        setEditorLoaded(true);
      }
    }
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []); // ✅ empty array means run once on mount

  const getcategoryNameList = async () => {
    try {
      var data = {
        apiUrl: apiService.get_blog_category_list,
      };
      var resp = await getMethod(data);
      console.log("category list====", resp);
      if (resp.success == true) {
        setcategoryNameList(resp.data);
      }
    } catch (error) {}
  };

  const getBlocksentinalblogList = async (page, search = "") => {
    try {
      var payload = {
        perpage: 5,
        page: page,
        search,
      };
      var data = {
        apiUrl: apiService.get_Blocksentinal_blog_List,
        payload: payload,
      };
      setpageblockloader(true);
      var resp = await postMethod(data);
      setpageblockloader(false);
      if (resp.success == true) {
        setBlocksentinalblogList(resp.data.data);
        console.log(resp.data.data);
        setBlocksentinaltotalPages(resp.data.pages);
      } else {
        setBlocksentinalblogList([]);
      }
    } catch (error) {}
  };
  const getblogList = async (page, search = "") => {
    try {
      var payload = {
        perpage: 5,
        page: page,
        search,
      };
      var data = {
        apiUrl: apiService.get_blog_list,
        payload: payload,
      };
      setpageloader(true);
      var resp = await postMethod(data);
      setpageloader(false);
      if (resp.success == true) {
        setblogList(resp.data.data);
        console.log(resp.data.data);
        setTotalpages(resp.data.pages);
      } else {
        setblogList([]);
      }
    } catch (error) {}
  };
  const [imageLoader, setimageLoader] = useState(false);

  const imageUpload = (val) => {
    console.log("val===", val);
    const fileExtension = val.name.split(".").at(-1);
    const fileSize = val.size;
    const fileName = val.name;
    console.log("fileExtension===", fileExtension);
    console.log("fileSize===", fileSize);
    console.log("fileName===", fileName);
    if (
      fileExtension != "png" &&
      fileExtension != "jpg" &&
      fileExtension != "jpeg" &&
      fileExtension != "webp"
    ) {
      toast.error("File does not support. You must use .png or .jpg or .jpeg ");
      return false;
    } else if (fileSize > 1000000) {
      toast.error("Please upload a file smaller than 1 MB");
      return false;
    } else {
      setimageLoader(true);
      const data = new FormData();
      data.append("file", val);
      data.append("upload_preset", "ebjirh4i");
      data.append("cloud_name", "blf");
      console.log("formdata===", data);
      fetch("  https://api.cloudinary.com/v1_1/blf/auto/upload", {
        method: "post",
        body: data,
      })
        .then((resp) => resp.json())
        .then((data) => {
          setimageLoader(false);
          console.log("cloudinary upload===", data);
          setblogImage(data.secure_url);
          setblogLabel(fileName);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const setblogUrl = (val) => {
    var title = val;
    setblogTitle(title);
    var slug = title
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");
    setblogSlug(slug);
  };

  const setblogContents = (data) => {
    console.log("blog data====", data);
    setblogContent(data);
  };

  const editBlog = async (
    title,
    slug,
    metatitle,
    metadesc,
    category,
    image,
    status,
    content,
    history,
    setIsLoading,
  ) => {
    console.log(category);
    var data = {
      apiUrl: apiService.editBlog,
      payload: {
        _id: blogdataref.current,
        title: title,
        slug: slug,
        metatitle: metatitle,
        metadescription: metadesc,
        category: category,
        image: image,
        status: status,
        content: content,
      },
    };
    console.log(data, "payload=-=-=-data-=-=-=-=-=-=---0-0-0-");
    var resp = await postMethod(data);
    console.log(resp, "resp=-=-=-resp-=-=-=-=-=-=---0-0-0-");

    if (resp) {
      toast(resp.Message);
      getblogList();
      setformStatus(false);
      // setActivePage(false)
    }
  };

  const viewBlog = async (e) => {
    console.log(e, "=========value");
    setActivePage(true);
    setformStatus(true);
    console.log(e, "=========value");
    setBlog(e._id);
    setblogTitle(e.title);
    setblogSlug(e.slug);
    setblogMetatitle(e.metatitle);
    setblogMetadesc(e.metadescription);
    setcatagoryNameValue(e.category_id);
    setblogImage(e.image);
    setblogContent(e.content);
    setblogStausValue(e.status);
    setblogSite(e.blogSite);
  };
  const [deleteId, setdeleteId] = useState("");
  const deleteBlog = async (e) => {
    console.log(e);
    var obj = { e };
    var data = {
      apiUrl: apiService.deleteblog,
      payload: obj,
    };
    var resp = await postMethod(data);
    if (resp) {
      toast(resp.Message);
      setformStatus(false);
      getblogList();
      getBlocksentinalblogList();
      handleClose();
    }
  };
  return (
    <>
      {/* {pageloader == true ? (
        <div className="loader">
          <CircularProgress />
        </div>
      ) : ( */}
      <>
        {formStatus == true ? (
          <>
            {formStatus == false ? (
              <div onClick={() => setformStatus(true)} className="btn_add">
                <span>Add</span>
                <Icons.AddCircle />
              </div>
            ) : (
              <div className="d-flex justify-content-between align-items-center">
                {/* <PageTitle title="Blog Upload" /> */}
                <div onClick={() => setformStatus(false)} className="mb-3">
                  <button className="btn btn-primary custom_btn text-white">
                    Back
                  </button>
                </div>
              </div>
            )}

            {pageactive == false ? (
              <div className="card blog_upload_card">
                <div className="row">
                  <div className="col-md-6">
                    {" "}
                    <div className="form-group">
                      <label className="blg_upld_label">Blog Title</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Blog Title"
                        value={blogTitle}
                        onChange={(e) => setblogUrl(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    {" "}
                    <div className="form-group mb-4">
                      <label
                        className="blg_upld_label"
                        htmlFor="exampleInputPassword1"
                      >
                        Blog URL
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Blog URL"
                        value={blogSlug}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    {" "}
                    <div className="form-group mb-4">
                      <label
                        className="blg_upld_label"
                        htmlFor="exampleInputPassword1"
                      >
                        Blog META title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Blog META title"
                        value={blogMetatitle}
                        onChange={(e) => setblogMetatitle(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    {" "}
                    <div className="form-group mb-4">
                      <label className="blg_upld_label">Status</label>
                      <select
                        className="form-control"
                        id="exampleFormControlSelect1"
                        onChange={(e) => setblogStausValue(e.target.value)}
                      >
                        <option value="Active">Active</option>
                        <option value="Deactive">Deactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label
                        className="blg_upld_label"
                        htmlFor="exampleInputPassword1"
                      >
                        Blog category
                      </label>
                      <select
                        className="form-control"
                        id="exampleFormControlSelect1"
                        onChange={(e) => setcatagoryNameValue(e.target.value)}
                      >
                        {categoryNameList &&
                          categoryNameList.map((option) => (
                            <option value={option._id}>
                              {option.categoryname}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="blg_upld_label">Site name</label>
                      <select
                        className="form-control"
                        id="exampleFormControlSelect1"
                        onChange={(e) => setblogSite(e.target.value)}
                      >
                        <option value="BLF">BLF</option>
                        <option value="Blocksentels">Blocksentels</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label
                        className="blg_upld_label"
                        htmlFor="exampleInputPassword1"
                      >
                        Blog Image
                      </label>
                      {/* <div className="custom-file">
                              <input
                                type="file"
                                className="custom-file-input"
                                id="customFile"
                                onChange={(e) => imageUpload(e.target.files[0])}
                              />
                              <label className="blg_upld_label"
                                className="custom-file-label"
                                htmlFor="customFile"
                              >
                                {blogLabel}
                              </label>
                            </div> */}
                      <div className="selected_img_container">
                        {imageLoader == true ? (
                          <div className="blg_file_input_wrap">
                            <i class="fa-solid fa-spinner fa-spin"></i>
                          </div>
                        ) : blogImage ? (
                          <>
                            <input
                              type="file"
                              className="selected_img_file_input"
                              id="customFile"
                              onChange={(e) => imageUpload(e.target.files[0])}
                            />
                            <img src={blogImage} alt="Blog" className="w-100" />
                            {/* <label className="blg_upld_label"
                                >
                                  {blogLabel}
                                </label> */}
                          </>
                        ) : (
                          <div className="blg_file_input_wrap">
                            <i class="fa-solid fa-cloud-arrow-up"></i>
                            <label className="blg_upld_label">Upload</label>
                            <input
                              type="file"
                              className="blg_file_input"
                              id="customFile"
                              onChange={(e) => imageUpload(e.target.files[0])}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label
                        className="blg_upld_label"
                        htmlFor="exampleInputPassword1"
                      >
                        Blog META Description
                      </label>
                      <textarea
                        rows="5"
                        className="form-control"
                        onChange={(e) => setblogMetadesc(e.target.value)}
                      >
                        {blogMetadesc}
                      </textarea>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group mb-4">
                      <label
                        className="blg_upld_label"
                        htmlFor="exampleInputPassword1"
                      >
                        Blog Content
                      </label>
                      <CKeditor
                        name="description"
                        onChange={(data) => {
                          setblogContents(data);
                        }}
                        editorLoaded={editorLoaded}
                      />
                    </div>
                  </div>
                  <button
                    disabled={
                      blogTitle.length === 0 ||
                      blogSlug.length === 0 ||
                      blogMetatitle.length === 0 ||
                      blogMetadesc.length === 0 ||
                      categoryNameValue.length === 0 ||
                      blogImage.length === 0 ||
                      blogContent.length === 0 ||
                      blogStatus.length === 0 ||
                      blogSite.length === 0
                    }
                    className="btn btn-primary custom_btn"
                    onClick={(e) => (
                      e.preventDefault(),
                      insertBlog(
                        blogTitle,
                        blogSlug,
                        blogMetatitle,
                        blogMetadesc,
                        categoryNameValue,
                        blogImage,
                        blogContent,
                        blogStatus,
                        blogSite,
                        props.history,
                        // setIsLoading,
                        // setError
                      ),
                      getBlocksentinalblogList(),
                      getblogList(),
                      setformStatus(false)
                    )}
                  >
                    Submit
                  </button>
                </div>
              </div>
            ) : (
              <>
                <>
                  <div className="card blog_upload_card">
                    <div className="row">
                      {/* Left Column */}
                      <div className="col-md-6">
                        <div className="form-group mb-4">
                          <label className="blg_upld_label">Blog Title</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Blog Title"
                            value={blogTitle}
                            onChange={(e) => setblogUrl(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-4">
                          <label className="blg_upld_label">Blog URL</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Blog URL"
                            value={blogSlug}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-4">
                          <label className="blg_upld_label">
                            Blog META title
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Blog META title"
                            value={blogMetatitle}
                            onChange={(e) => setblogMetatitle(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-4">
                          <label className="blg_upld_label">Status</label>
                          <select
                            className="form-control"
                            value={blogStatus}
                            onChange={(e) => setblogStausValue(e.target.value)}
                          >
                            <option value="Active">Active</option>
                            <option value="Deactive">Deactive</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-4">
                          <label className="blg_upld_label">
                            Blog category
                          </label>
                          <select
                            className="form-control"
                            onChange={(e) =>
                              setcatagoryNameValue(e.target.value)
                            }
                          >
                            {categoryNameList &&
                              categoryNameList.map((option) => (
                                <option key={option._id} value={option._id}>
                                  {option.categoryname}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-4">
                          <label className="blg_upld_label">Site name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Site name"
                            value={blogSite}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-4">
                          <label className="blg_upld_label">Blog Image</label>
                          {/* <img width="200" src={blogImage} alt="Blog" /> */}
                          <div className="selected_img_container">
                            {imageLoader == true ? (
                              <div className="blg_file_input_wrap">
                                <i class="fa-solid fa-spinner fa-spin"></i>
                              </div>
                            ) : blogImage ? (
                              <>
                                <input
                                  type="file"
                                  className="selected_img_file_input"
                                  id="customFile"
                                  onChange={(e) =>
                                    imageUpload(e.target.files[0])
                                  }
                                />
                                <img
                                  src={blogImage}
                                  alt="Blog"
                                  className="w-100"
                                />
                                {/* <label
                                >
                                  {blogLabel}
                                </label> */}
                              </>
                            ) : (
                              <div className="blg_file_input_wrap">
                                <i class="fa-solid fa-cloud-arrow-up"></i>
                                <label>Upload</label>
                                <input
                                  type="file"
                                  className="blg_file_input"
                                  id="customFile"
                                  onChange={(e) =>
                                    imageUpload(e.target.files[0])
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-4">
                          <label className="blg_upld_label">
                            Blog META Description
                          </label>
                          <textarea
                            rows="5"
                            value={blogMetadesc}
                            className="form-control"
                            onChange={(e) => setblogMetadesc(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <>
                          <div className="form-group mb-4 blg_upload_editor">
                            <label className="blg_upld_label">
                              Blog Content
                            </label>
                            <CKeditor
                              name="description"
                              value={blogContent}
                              onChange={(data) => setblogContents(data)}
                              editorLoaded={editorLoaded}
                              data={blogContent}
                            />
                          </div>

                          <button
                            disabled={
                              blogTitle.length === 0 ||
                              blogSlug.length === 0 ||
                              blogMetatitle.length === 0 ||
                              blogMetadesc.length === 0 ||
                              categoryNameValue.length === 0 ||
                              blogImage.length === 0 ||
                              blogContent.length === 0 ||
                              blogStatus.length === 0
                            }
                            className="btn btn-primary custom_btn"
                            onClick={(e) => {
                              e.preventDefault();
                              editBlog(
                                blogTitle,
                                blogSlug,
                                blogMetatitle,
                                blogMetadesc,
                                categoryNameValue,
                                blogImage,
                                blogStatus,
                                blogContent,
                                props.history,
                              );
                              getBlocksentinalblogList();
                              getblogList();
                              setformStatus(false);
                            }}
                          >
                            UpdateBlog
                          </button>
                        </>
                      </div>
                    </div>
                  </div>
                </>
              </>
            )}
          </>
        ) : (
          <>
            <div>
              <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between py-4 mb-3">
                <Typography
                  fullWidth
                  color="inherit"
                  className={classes.blog_categories}
                  variant="body2"
                  sx={{ mt: 1 }}
                >
                  Beleaf Blogs
                </Typography>
                <div className="right_top">
                  <SearchBar
                    placeholder="Search by Title"
                    onSearch={(term) => getblogList(1, term, "Tittle")}
                  />
                  {formStatus == false ? (
                    <div
                      onClick={() => (
                        setformStatus(true),
                        setblogTitle(""),
                        setblogSlug(""),
                        setblogMetatitle(""),
                        setblogMetadesc(""),
                        setblogImage(""),
                        setblogContent(""),
                        setblogLabel(""),
                        setblogStausValue(""),
                        setblogSite("")
                      )}
                      className="btn_add"
                    >
                      <span>Add</span>
                      <Icons.AddCircle />
                    </div>
                  ) : (
                    <div onClick={() => setformStatus(false)}>
                      <button className="btn btn-primary custom_btn text-white">
                        Back
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="table_outer">
                <div className="table-responsive">
                  <table className="table m-0 table-striped">
                    <thead className="admin_thead">
                      <tr>
                        <th> S.No</th>
                        <th> Blog Title </th>
                        <th> Category Name </th>
                        <th> Image </th>
                        <th> Status </th>
                        <th> Edit </th>
                        <th> Delete</th>
                      </tr>
                    </thead>

                    <tbody className="admin_tbody">
                      {pageloader === true ? (
                        Array.from({ length: 6 }).map((_, i) => (
                          <tr key={i}>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                          </tr>
                        ))
                      ) : blogListref.current.length > 0 ? (
                        blogListref.current &&
                        blogListref.current.map((blogs, i) => {
                          return (
                            <tr>
                              <td>{i + 1}</td>
                              <td>{blogs.title}</td>
                              <td>{blogs.category}</td>
                              <td>
                                <img width="50" src={blogs.image} />
                              </td>
                              <td>
                                {blogs.status == "Active" ? (
                                  <p
                                    className="mb-0"
                                    style={{ color: "green" }}
                                  >
                                    {" "}
                                    Active{" "}
                                  </p>
                                ) : (
                                  <p className="mb-0" style={{ color: "red" }}>
                                    {" "}
                                    Deactive{" "}
                                  </p>
                                )}
                              </td>
                              <td onClick={() => viewBlog(blogs)}>
                                <i className="fa fa-edit"></i>
                                <a href="javascript:void(0)"> </a>
                              </td>
                              <td
                                onClick={() => (
                                  handleOpen(), setdeleteId(blogs._id)
                                )}
                              >
                                <i className="fa fa-trash"></i>
                                {/* <a href="javascript:void(0)"> Delete </a> */}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className="no-record">
                          <td colSpan={7}>
                            <div className="emptyrecordimg">
                              <img
                                src={require("../images/No-data.webp")}
                                width="100px"
                              />
                              <span className="emptyrecord">
                                No records found
                              </span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* <Pagination
          itemClassName="page-item" // add it for bootstrap 4
          linkClassName="page-link" // add it for bootstrap 4
          activePage={currentPage}
          itemsCountPerPage={recordPerPage}
          totalItemsCount={totalPage}
          pageRangeDisplayed={pageRange}
          onChange={handlePageChange}
        /> */}
              <Pagination
                count={totalPage}
                page={currentPage}
                onChange={(e, value) => handlePageChange(value)}
                className={`${classes.blog_pagination} mt-4`}
                color="primary"
                shape="rounded"
              />
            </div>
            <div>
              <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between py-4 mb-3">
                {" "}
                <Typography
                  fullWidth
                  color="inherit"
                  className={classes.blog_categories}
                  variant="body2"
                  sx={{ mt: 1 }}
                >
                  Block Sentinals Blogs
                </Typography>
                <div className="right_top">
                  <SearchBar
                    placeholder="Search by Title"
                    onSearch={(term) =>
                      getBlocksentinalblogList(1, term, "Tittle")
                    }
                  />
                  {formStatus == false ? (
                    <div
                      onClick={() => (
                        setformStatus(true),
                        setblogTitle(""),
                        setblogSlug(""),
                        setblogMetatitle(""),
                        setblogMetadesc(""),
                        setblogImage(""),
                        setblogContent(""),
                        setblogLabel(""),
                        setblogStausValue(""),
                        setblogSite("")
                      )}
                      className="btn_add"
                    >
                      <span>Add</span>
                      <Icons.AddCircle />
                    </div>
                  ) : (
                    <div onClick={() => setformStatus(false)}>
                      <button className="btn btn-primary custom_btn text-white">
                        Back
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="table_outer">
                <div className="table-responsive">
                  <table className="table m-0 table-striped">
                    <thead className="admin_thead">
                      <tr>
                        <th> S.No</th>
                        <th> Blog Title </th>
                        <th> Category Name </th>
                        <th> Image </th>
                        <th> Status </th>
                        <th> Edit </th>
                        <th> Delete</th>
                      </tr>
                    </thead>
                    <tbody className="admin_tbody">
                      {pageblockloader === true ? (
                        Array.from({ length: 6 }).map((_, i) => (
                          <tr key={i}>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>{" "}
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                          </tr>
                        ))
                      ) : BlocksentinalblogListref.current.length > 0 ? (
                        BlocksentinalblogListref.current &&
                        BlocksentinalblogListref.current.map((blogs, i) => {
                          return (
                            <tr>
                              <td>{i + 1}</td>
                              <td>{blogs.title}</td>
                              <td>{blogs.category}</td>
                              <td>
                                <img width="50" src={blogs.image} />
                              </td>
                              <td>
                                {blogs.status == "Active" ? (
                                  <p
                                    className="mb-0"
                                    style={{ color: "green" }}
                                  >
                                    {" "}
                                    Active{" "}
                                  </p>
                                ) : (
                                  <p className="mb-0" style={{ color: "red" }}>
                                    {" "}
                                    Deactive{" "}
                                  </p>
                                )}
                              </td>
                              <td onClick={() => viewBlog(blogs)}>
                                <i className="fa fa-edit"></i>
                                <a href="javascript:void(0)"> </a>
                              </td>
                              <td
                                onClick={() => (
                                  handleOpen(), setdeleteId(blogs._id)
                                )}
                              >
                                <i className="fa fa-trash"></i>
                                {/* <a href="javascript:void(0)"> Delete </a> */}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className="no-record">
                          <td colSpan={7}>
                            <div className="emptyrecordimg">
                              <img
                                src={require("../images/No-data.webp")}
                                width="100px"
                              />
                              <span className="emptyrecord">
                                No records found
                              </span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {BlocksentinaltotalPage > 1 && (
                <Pagination
                  count={BlocksentinaltotalPage}
                  page={BlocksentinalcurrentPage}
                  onChange={(e, value) => handlePageBlocksentinalChange(value)}
                  className={`${classes.blog_pagination} mt-4`}
                  color="primary"
                  shape="rounded"
                />
              )}
            </div>
          </>
        )}
      </>

      <div>
        {/* <Button >Open modal</Button> */}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <h5 className="logout_title">Delete Notification</h5>
            <p className="logout_content">Are your sure delete this item</p>
            <div className="logout_btn_wrapper">
              <button
                className="logout_cancel custom_btn2 text-center"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="logout_confirm custom_btn2 text-center"
                onClick={() => deleteBlog(deleteId)}
              >
                Delete
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}
